import React, { type FunctionComponent } from 'react'
import styled from '@emotion/styled'
import { type DashRouteComponentProps } from 'legacy/dash-components/dash-route/utils/dashRoute.types'
import DocumentTitle from 'legacy/components/DocumentTitle'
import { StorePerformanceOverviewContent } from 'domains/aggregate-store-performance/components/store-performance-overview-content/StorePerformanceOverviewContent'
import { useStoreOpsNav } from 'domains/aggregate-store-performance/utils/useStoreOpsNav'

const PageContainer = styled.div({
  height: '100vh',
  display: 'flex',
  flexDirection: 'column',
  overflow: 'hidden',
})

interface Props
  extends DashRouteComponentProps<{
    /*
    Add here any properties that you expect to come from the route. For instance,

    id: string
  */
  }> {}

export const AggregateStorePerformanceOverviewPage: FunctionComponent<Props> = () => {
  // Store Operations is the new flavor.
  // Delete this and go with the `true` case once `dashboard_store_ops_nav` flipper is fully enabled.
  const useStoreOps = useStoreOpsNav()

  return (
    <PageContainer>
      <DocumentTitle
        titleId={
          useStoreOps
            ? 'aggregateStorePerformanceDomain.title.new'
            : 'aggregateStorePerformanceDomain.title'
        }
      />
      <StorePerformanceOverviewContent />
    </PageContainer>
  )
}
